export const actionTypes = {
    resetAllStates: "[main] Reset state to default",
};
